export const speciesData = [
    {
      id: 'Drosophila_melanogaster',
      name: 'Drosophila melanogaster',
      updateInfo: 'Updated: 8/2018 | Samples: 9924 | Series: 368',
      data: [
        {
          description: 'Gene counts',
          size: '206MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Drosophila_melanogaster_genecount_v1.h5',
        },
        {
          description: 'Kallisto index',
          size: '674MB',
          url: 'https://s3.amazonaws.com/mssm-seq-index/Drosophila_melanogaster_index.idx',
        },
        {
          description: 'Transcript counts',
          size: '375MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Drosophila_melanogaster_transcript_v1.h5',
        },
        {
          description: 'Gene mapping',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-seq-genemapping/Drosophila_melanogaster_mapping.rda',
        },
        {
          description: 'Transcript TPM',
          size: '1.2GB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Drosophila_melanogaster_tpm_v1.h5',
        },
        {
          description: 'Alignment quality',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Drosophila_melanogaster_alignment_quality.rda',
        },
      ],
    },
    {
      id: 'Bos_taurus',
      name: 'Bos taurus',
      updateInfo: 'Updated: 8/2018 | Samples: 2039 | Series: 69',
      data: [
        {
          description: 'Gene counts',
          size: '60MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Bos_taurus_genecount_v1.h5',
        },
        {
          description: 'Kallisto index',
          size: '819MB',
          url: 'https://s3.amazonaws.com/mssm-seq-index/Bos_taurus_index.idx',
        },
        {
          description: 'Transcript counts',
          size: '64MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Bos_taurus_transcript_v1.h5',
        },
        {
          description: 'Gene mapping',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-seq-genemapping/Bos_taurus_mapping.rda',
        },
        {
          description: 'Transcript TPM',
          size: '192MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Bos_taurus_tpm_v1.h5',
        },
        {
          description: 'Alignment quality',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Bos_taurus_alignment_quality.rda',
        },
      ],
    },
    {
      id: 'Caenorhabditis_elegans',
      name: 'Caenorhabditis elegans',
      updateInfo: 'Updated: 8/2018 | Samples: 2935 | Series: 182',
      data: [
        {
          description: 'Gene counts',
          size: '84MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Caenorhabditis_elegans_genecount_v1.h5',
        },
        {
          description: 'Kallisto index',
          size: '596MB',
          url: 'https://s3.amazonaws.com/mssm-seq-index/Caenorhabditis_elegans_index.idx',
        },
        {
          description: 'Transcript counts',
          size: '122MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Caenorhabditis_elegans_transcript_v1.h5',
        },
        {
          description: 'Gene mapping',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-seq-genemapping/Caenorhabditis_elegans_mapping.rda',
        },
        {
          description: 'Transcript TPM',
          size: '400MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Caenorhabditis_elegans_tpm_v1.h5',
        },
        {
          description: 'Alignment quality',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Caenorhabditis_elegans_alignment_quality.rda',
        },
      ],
    },
    {
      id: 'Danio_rerio',
      name: 'Danio rerio',
      updateInfo: 'Updated: 8/2018 | Samples: 4004 | Series: 223',
      data: [
        {
          description: 'Gene counts',
          size: '126MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Danio_rerio_genecount_v1.h5',
        },
        {
          description: 'Kallisto index',
          size: '1.4GB',
          url: 'https://s3.amazonaws.com/mssm-seq-index/Danio_rerio_index.idx',
        },
        {
          description: 'Transcript counts',
          size: '192MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Danio_rerio_transcript_v1.h5',
        },
        {
          description: 'Gene mapping',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-seq-genemapping/Danio_rerio_mapping.rda',
        },
        {
          description: 'Transcript TPM',
          size: '657MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Danio_rerio_tpm_v1.h5',
        },
        {
          description: 'Alignment quality',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Danio_rerio_alignment_quality.rda',
        },
      ],
    },
    {
      id: 'Gallus_gallus',
      name: 'Gallus gallus',
      updateInfo: 'Updated: 8/2018 | Samples: 1649 | Series: 82',
      data: [
        {
          description: 'Gene counts',
          size: '41MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Gallus_gallus_genecount_v1.h5',
        },
        {
          description: 'Kallisto index',
          size: '754MB',
          url: 'https://s3.amazonaws.com/mssm-seq-index/Gallus_gallus_index.idx',
        },
        {
          description: 'Transcript counts',
          size: '62MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Gallus_gallus_transcript_v1.h5',
        },
        {
          description: 'Gene mapping',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-seq-genemapping/Gallus_gallus_mapping.rda',
        },
        {
          description: 'Transcript TPM',
          size: '186MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Gallus_gallus_tpm_v1.h5',
        },
        {
          description: 'Alignment quality',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Gallus_gallus_alignment_quality.rda',
        },
      ],
    },
    {
      id: 'Rattus_norvegicus',
      name: 'Rattus norvegicus',
      updateInfo: 'Updated: 8/2018 | Samples: 3373 | Series: 184',
      data: [
        {
          description: 'Gene counts',
          size: '110MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Rattus_norvegicus_genecount_v1.h5',
        },
        {
          description: 'Kallisto index',
          size: '1.0GB',
          url: 'https://s3.amazonaws.com/mssm-seq-index/Rattus_norvegicus_index.idx',
        },
        {
          description: 'Transcript counts',
          size: '140MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Rattus_norvegicus_transcript_v1.h5',
        },
        {
          description: 'Gene mapping',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-seq-genemapping/Rattus_norvegicus_mapping.rda',
        },
        {
          description: 'Transcript TPM',
          size: '431MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Rattus_norvegicus_tpm_v1.h5',
        },
        {
          description: 'Alignment quality',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Rattus_norvegicus_alignment_quality.rda',
        },
      ],
    },
    {
      id: 'Saccharomyces_cerevisiae',
      name: 'Saccharomyces cerevisiae',
      updateInfo: 'Updated: 8/2018 | Samples: 3268 | Series: 214',
      data: [
        {
          description: 'Gene counts',
          size: '37MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Saccharomyces_cerevisiae_genecount_v1.h5',
        },
        {
          description: 'Kallisto index',
          size: '167MB',
          url: 'https://s3.amazonaws.com/mssm-seq-index/Saccharomyces_cerevisiae_index.idx',
        },
        {
          description: 'Transcript counts',
          size: '37MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Saccharomyces_cerevisiae_transcript_v1.h5',
        },
        {
          description: 'Gene mapping',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-seq-genemapping/Saccharomyces_cerevisiae_mapping.rda',
        },
        {
          description: 'Transcript TPM',
          size: '97MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Saccharomyces_cerevisiae_tpm_v1.h5',
        },
        {
          description: 'Alignment quality',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Saccharomyces_cerevisiae_alignment_quality.rda',
        },
      ],
    },
    {
      id: 'Arabidopsis_thaliana',
      name: 'Arabidopsis thaliana',
      updateInfo: 'Updated: 8/2018 | Samples: 7875 | Series: 442',
      data: [
        {
          description: 'Gene counts',
          size: '332MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Arabidopsis_thaliana_genecount_v1.h5',
        },
        {
          description: 'Kallisto index',
          size: '929MB',
          url: 'https://s3.amazonaws.com/mssm-seq-index/Arabidopsis_thaliana_index.idx',
        },
        {
          description: 'Transcript counts',
          size: '507MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Arabidopsis_thaliana_transcript_v1.h5',
        },
        {
          description: 'Gene mapping',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-seq-genemapping/Arabidopsis_thaliana_mapping.rda',
        },
        {
          description: 'Transcript TPM',
          size: '1.6GB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Arabidopsis_thaliana_tpm_v1.h5',
        },
        {
          description: 'Alignment quality',
          size: '< 1MB',
          url: 'https://s3.amazonaws.com/mssm-archs4-zoo/Arabidopsis_thaliana_alignment_quality.rda',
        },
      ],
    },
  ];